import { RecommendedLecturesPlayableCard } from '../cards/RecomendedLecturesPlayable.tsx';
import { UilSignout, UilSun, UilSunset } from '@iconscout/react-unicons';
import { useFetchRecommendedLectures } from '../../lib/fetches.ts';
import Skeleton from '../Skeleton.tsx';
import { useState } from 'react';
import { cn } from '../../lib/helpers.ts';

export default function RecommendedLectures() {
    const { data: recommendedLectures, isLoading } =
        useFetchRecommendedLectures();

    const icons = {
        sunset: UilSunset,
        sun: UilSun,
        signout: UilSignout,
    };

    const [activeRecommendedLecture, setActiveRecommendedLecture] = useState<
        string | null
    >(null);

    return (recommendedLectures && recommendedLectures.length > 0) ||
        isLoading ? (
        <div>
            <h2 className="mb-6">Doporučená cvičení</h2>
            <div className={cn('grid gap-8', 'grid-cols-1 md:grid-cols-3')}>
                {recommendedLectures?.map((category) => (
                    <RecommendedLecturesPlayableCard
                        key={category.slug}
                        heading={category.name}
                        slug={category.slug}
                        icon={icons[category?.icon as keyof typeof icons]}
                        color={category?.color}
                        lectures={category.lectures}
                        activeLecture={activeRecommendedLecture}
                        setActiveLecture={setActiveRecommendedLecture}
                    />
                ))}

                {isLoading && (
                    <Skeleton count={3} className="h-80 w-full rounded-xl" />
                )}
            </div>
        </div>
    ) : null;
}
